import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { trackPromoSearchClickAction } from '../../actions/analytics';
import { FakeSearchInput } from '../../components/FakeSearchInput';
import { INPUT_PLACEHOLDER } from '../../constants/strings';
import { selectIsCompilation } from '../../selectors/compilation';
import { selectCurrentTags } from '../../selectors/tags';
import { TThunkDispatch } from '../../types/redux/thunk';
import { stringifyTags } from '../../utils/tags';
import { SearchModalContainer } from '../SearchModal';

export const FakeSearchInputContainer: React.FC = () => {
  const [isOpened, setOpened] = React.useState<boolean>(false);
  const isCompilation = useSelector(selectIsCompilation);
  const tags = useSelector(selectCurrentTags);
  const dispatch: TThunkDispatch = useDispatch();

  const inputValue = React.useMemo(() => stringifyTags(tags), [tags]);

  const handleClick = React.useCallback(() => {
    setOpened(true);
    dispatch(trackPromoSearchClickAction());
  }, [dispatch]);

  const handleModalClose = React.useCallback(() => {
    setOpened(false);
  }, []);

  if (isCompilation) {
    return null;
  }

  return (
    <>
      <FakeSearchInput placeholder={INPUT_PLACEHOLDER} onClick={handleClick} value={inputValue} />
      <SearchModalContainer open={isOpened} onClose={handleModalClose} />
    </>
  );
};
